import { SET_CONFIG } from "../actions/appAction";
import { 
    CHANGE_CHAT_SERVICE, 
    CHAT_ENDED, 
    CHAT_RATED, 
    CHAT_STARTED, 
    RATE_BAD, 
    RATE_GOOD, 
    CHAT_SID,
    CHAT_TOKEN,
    CHAT_UUID,
    NOT_CHATTING,
    AGENT_START_TYPING,
    AGENT_STOP_TYPING,
    AGENT_STATUS,
    SURVEY_SUBMITTED,
    CHAT_ACTIVITYID
} from "../actions/chatAction";

const initialState = {
    appConfig: null,    
	chatState: 'NOT_CHATTING',
	widgetState: 'MAXIMIZED',
	chatService: 'botEngine',
    rate: 'none',
    sid: '',
    activityid:'',
    token: '',
    uid : '',
    agentTyping: false,
    agentStatus: {
        status: 'available',
        time: 0,
        message:''
    }
};

export default function(state = initialState, action) {
    switch(action.type) {
        case SET_CONFIG:
            return {
                ...state,
                appConfig: action.payload
            };
        case CHAT_STARTED:
            return { 
                ...state,
                chatState: 'CHATTING',
                chatService: 'LiveChat', 
            };
        case CHANGE_CHAT_SERVICE:
            return {
                ...state,
                chatService: action.payload.chatService,
            };
        case NOT_CHATTING:
            return {
                ...state,
                chatState: 'NOT_CHATTING'
            };
        case CHAT_ENDED: 
            return {
                ...state,
                chatState: 'ENDED',
            };
        case SURVEY_SUBMITTED:
            return {
                ...state,
                chatState: SURVEY_SUBMITTED
            }
        case CHAT_RATED:
            return {
                ...state,
                rate: action.payload.rate || state.rate,
            };
        case RATE_GOOD: 
            return {
                ...state,
                rate: 'good',
            };
        case RATE_BAD:
            return {
                ...state,
                rate: 'bad',
            };
        case CHAT_SID: 
            return {
                ...state,
                sid: action.payload.sid
            }
        case CHAT_ACTIVITYID: 
            return {
                ...state,
                activityid: action.payload.activityid
            }
        case CHAT_TOKEN: 
            return {
                ...state,
                token: action.payload.token
            }
        case CHAT_UUID: 
            return {
                ...state,
                uid: action.payload.uid
            }
        case AGENT_START_TYPING:
            return {
                ...state,
                agentTyping: true
            };
        case AGENT_STOP_TYPING:
            return {
                ...state,
                agentTyping: false
            };
        case AGENT_STATUS:
            return {
                ...state,
                agentStatus: action.payload
            }
        default:
            return state;
    }
}

export const getChatState = state => state.app.chatState;
export const getWidgetState = state => state.app.widgetState;
export const getChatService = state => state.app.chatService;
export const getRate = state => state.app.rate;
export const getSid = state => state.app.sid;
export const getActivityID = state => state.app.activityid;
export const getToken= state => state.app.token;
export const getUUID = state => state.app.uid;
export const getAgentTypingStatus = state => state.app.agentTyping;
export const getAgentStatus = state => state.app.agentStatus;
export const getConfig = state => state.app.appConfig;